module.exports = __webpack_public_path__ + "img/z16.1d96eacf.gif";